import { ExerciseSelection } from '../../entities';
import { WorkoutSettings } from '../../entities/user/workoutsettings';
import { Exercise } from './../../entities/exercise/exercise';
import { IExerciseSelectionFilter } from './workoutselectionmanager';

export class CompatibleZoneFilter implements IExerciseSelectionFilter {
    public description: string = 'Return only exercises that are compatable with this zone';
    public name: string = 'CompatibleZoneFilter';
    public filter(inputExercises: Exercise[],
                  exerciseSelection: ExerciseSelection,
                  userWorkoutSettings: WorkoutSettings,
                  selectedZoneExercisesSoFar: Exercise[],
                  workoutStartDate: Date): Exercise[] {
        return inputExercises.filter((e) => e.compatibleZones.indexOf(exerciseSelection.zone) !== -1);
    }
}
